function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDropbox = function SvgDropbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e88e5"
    },
    d: "M512 99.136 361.376 0 256 88.672l151.872 94.496zM150.624 0 0 99.104l104.16 84.064L256 88.672zM256 277.696l-105.376 88.672L0 267.232l104.128-84.064L256 277.696l151.84-94.528L512 267.232l-150.624 99.136z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1e88e5"
    },
    d: "M368.992 399.648a15.88 15.88 0 0 1-8.768 2.624c-3.68 0-7.328-1.28-10.304-3.744L256 319.488l-93.92 79.04c-5.408 4.544-13.184 4.992-19.104 1.12L96 368.736V416l160.32 96L416 416v-47.296l-47.008 30.944z"
  }));
};
export default SvgDropbox;